export const criiptoAuthMethodsByCountry = [
    {
        countryCode: 'se',
        countryLabel: 'Sweden',
        methods: [
            {
                label: 'BankID',
                value: 'urn:grn:authn:se:bankid:another-device',
            },
            {
                label: 'BankID with QR',
                value: 'urn:grn:authn:se:bankid:another-device:qr',
            },
            {
                label: 'BankID this device',
                value: 'urn:grn:authn:se:bankid:same-device',
            },
        ],
    },
    {
        countryCode: 'no',
        countryLabel: 'Norway',
        methods: [
            {
                label: 'BankID',
                value: 'urn:grn:authn:no:bankid',
            },
            {
                label: 'BankID biometrics',
                value: 'urn:grn:authn:no:bankid:substantial',
            },
            {
                label: 'Vipps',
                value: 'urn:grn:authn:no:vipps',
            },
        ],
    },
    {
        countryCode: 'fi',
        countryLabel: 'Finland',
        methods: [
            {
                label: 'BankID',
                value: 'urn:grn:authn:fi:bank-id',
            },
            {
                label: 'Mobile ID',
                value: 'urn:grn:authn:fi:mobile-id',
            },
        ],
    },
    {
        countryCode: 'dk',
        countryLabel: 'Denmark',
        methods: [
            {
                label: 'MitID',
                value: 'urn:grn:authn:dk:mitid:low',
            },
        ],
    },
];
